var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/navigation-items.j2"] = require( "macros/navigation-items.j2" );
dependencies["back-to-catalog.j2"] = require( "back-to-catalog.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/breadcrumb-macro.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/breadcrumb-macro.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("categoryUrl")) {
var t_4 = t_1.categoryUrl;
} else {
cb(new Error("cannot import 'categoryUrl'")); return;
}
context.setVariable("categoryUrl", t_4);
if(t_1.hasOwnProperty("productUrl")) {
var t_5 = t_1.productUrl;
} else {
cb(new Error("cannot import 'productUrl'")); return;
}
context.setVariable("productUrl", t_5);
output += "\n";
env.getTemplate("macros/navigation-items.j2", false, "core/templates/macros/breadcrumb-macro.j2", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
t_6.getExported(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
if(t_6.hasOwnProperty("renderNavItem")) {
var t_9 = t_6.renderNavItem;
} else {
cb(new Error("cannot import 'renderNavItem'")); return;
}
context.setVariable("renderNavItem", t_9);
var macro_t_10 = runtime.makeMacro(
["breadcrumbs"], 
["currentItemWrapWithTagname", "core", "lastItemIsProduct", "isProductPage", "isMtoPage"], 
function (l_breadcrumbs, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("breadcrumbs", l_breadcrumbs);
frame.set("currentItemWrapWithTagname", kwargs.hasOwnProperty("currentItemWrapWithTagname") ? kwargs["currentItemWrapWithTagname"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("core", kwargs.hasOwnProperty("core") ? kwargs["core"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("lastItemIsProduct", kwargs.hasOwnProperty("lastItemIsProduct") ? kwargs["lastItemIsProduct"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isProductPage", kwargs.hasOwnProperty("isProductPage") ? kwargs["isProductPage"] : runtime.contextOrFrameLookup(context, frame, "False"));
frame.set("isMtoPage", kwargs.hasOwnProperty("isMtoPage") ? kwargs["isMtoPage"] : runtime.contextOrFrameLookup(context, frame, "False"));
var t_11 = "";t_11 += "\n    ";
if(l_breadcrumbs && env.getFilter("length").call(context, l_breadcrumbs) > 1 || runtime.contextOrFrameLookup(context, frame, "isProductPage")) {
t_11 += "\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12\">";
if(runtime.contextOrFrameLookup(context, frame, "isProductPage")) {
t_11 += "<div itemscope itemtype=\"http://schema.org/ItemPage\">\n            ";
;
}
else {
t_11 += "\n            <div itemscope itemtype=\"http://schema.org/CollectionPage\">\n            ";
;
}
t_11 += "\n                <nav class=\"c-breadcrumb\" role=\"navigation\" aria-label=\"breadcrumb navigation\" data-qa-breadcrumb-nav>\n\n                    <ol class=\"c-breadcrumb__ol u-clearfix\">";
if(runtime.contextOrFrameLookup(context, frame, "isProductPage")) {
env.getTemplate("back-to-catalog.j2", false, "core/templates/macros/breadcrumb-macro.j2", null, function(t_14,t_12) {
if(t_14) { cb(t_14); return; }
t_12.render(context.getVariables(), frame, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_11 += t_13
t_11 += "\n                        ";
})});
}
t_11 += "\n                        ";
if(l_breadcrumbs && env.getFilter("length").call(context, l_breadcrumbs) > 1) {
t_11 += "\n                            ";
frame = frame.push();
var t_18 = l_breadcrumbs;
if(t_18) {var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("crumb", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
t_11 += "\n                                ";
t_11 += runtime.suppressValue((lineno = 32, colno = 81, runtime.callWrap(t_9, "renderNavItem", context, [t_19,runtime.makeKeywordArgs({"caller": (function (){var macro_t_20 = runtime.makeMacro(
["navItemToRender", "url", "target"], 
[], 
function (l_navItemToRender, l_url, l_target, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("navItemToRender", l_navItemToRender);
frame.set("url", l_url);
frame.set("target", l_target);
var t_21 = "";t_21 += "\n                                    ";
var t_22;
t_22 = runtime.memberLookup((l_navItemToRender),"typeCode");
frame.set("crumbType", t_22, true);
if(frame.topLevel) {
context.setVariable("crumbType", t_22);
}
if(frame.topLevel) {
context.addExport("crumbType", t_22);
}
t_21 += "\n\n                                    ";
if(t_19) {
t_21 += "\n\n                                        ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")) {
t_21 += "\n                                        <li class=\"c-breadcrumb__li\" data-qa-breadcrumb=\"";
t_21 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_21 += "\">\n\n                                            ";
if(runtime.memberLookup((t_19),"slug") && runtime.contextOrFrameLookup(context, frame, "crumbType") != "HEADING") {
t_21 += "\n\n                                                ";
var t_23;
t_23 = "";
frame.set("analyticsData", t_23, true);
if(frame.topLevel) {
context.setVariable("analyticsData", t_23);
}
if(frame.topLevel) {
context.addExport("analyticsData", t_23);
}
t_21 += "\n\n                                                ";
if(runtime.contextOrFrameLookup(context, frame, "category")) {
var t_24;
t_24 = "category_site_promo_breadcrumb";
frame.set("analyticsSlug", t_24, true);
if(frame.topLevel) {
context.setVariable("analyticsSlug", t_24);
}
if(frame.topLevel) {
context.addExport("analyticsSlug", t_24);
}
var t_25;
t_25 = "L" + "" + runtime.memberLookup((t_19),"nestLevel") + "" + "-_-" + "" + runtime.memberLookup((t_19),"slug");
frame.set("analyticsData", t_25, true);
if(frame.topLevel) {
context.setVariable("analyticsData", t_25);
}
if(frame.topLevel) {
context.addExport("analyticsData", t_25);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isProductPage")) {
t_21 += "\n                                                    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"first")) {
t_21 += "\n                                                        ";
var t_26;
t_26 = "pdp_site_promo_breadcrumb_top";
frame.set("analyticsSlug", t_26, true);
if(frame.topLevel) {
context.setVariable("analyticsSlug", t_26);
}
if(frame.topLevel) {
context.addExport("analyticsSlug", t_26);
}
t_21 += "\n                                                    ";
;
}
else {
t_21 += "\n                                                        ";
var t_27;
t_27 = "pdp_site_promo_breadcrumb_mid";
frame.set("analyticsSlug", t_27, true);
if(frame.topLevel) {
context.setVariable("analyticsSlug", t_27);
}
if(frame.topLevel) {
context.addExport("analyticsSlug", t_27);
}
t_21 += "\n                                                    ";
;
}
t_21 += "\n                                                ";
;
}
;
}
t_21 += "\n\n                                                <a href=\"";
t_21 += runtime.suppressValue(env.getFilter("sanitize_url").call(context, l_url), env.opts.autoescape);
t_21 += "\" data-qa-breadcrumb-link=\"";
t_21 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_21 += "\" class=\"c-breadcrumb__a\"";
if(runtime.contextOrFrameLookup(context, frame, "isMtoPage")) {
t_21 += runtime.suppressValue((lineno = 57, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp","mto - TAB_TYPE","breadcrumb"])), env.opts.autoescape);
t_21 += "\n                                                ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isProductPage")) {
t_21 += "\n                                                    ";
t_21 += runtime.suppressValue((lineno = 59, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",(lineno = 59, colno = 67, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.analytics.productTypeSlug"])),"breadcrumb"])), env.opts.autoescape);
;
}
else {
t_21 += runtime.suppressValue((lineno = 61, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["breadcrumb",runtime.memberLookup((t_19),"slug")])), env.opts.autoescape);
;
}
;
}
t_21 += ">\n                                                    <span>";
t_21 += runtime.suppressValue(runtime.memberLookup((t_19),"displayName"), env.opts.autoescape);
t_21 += "</span>\n                                                </a>\n\n                                            ";
;
}
else {
t_21 += "\n\n                                                <span>";
t_21 += runtime.suppressValue(runtime.memberLookup((t_19),"displayName"), env.opts.autoescape);
t_21 += "</span>\n\n                                            ";
;
}
t_21 += "\n                                        </li>\n\n                                        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "lastItemIsProduct")) {
t_21 += "<li class=\"c-breadcrumb__li c-breadcrumb__li--last\" data-qa-breadcrumb=\"";
t_21 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_21 += "\">";
;
}
else {
t_21 += "<li class=\"c-breadcrumb__li c-breadcrumb__li--last\" data-qa-breadcrumb=\"";
t_21 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index"), env.opts.autoescape);
t_21 += "\">";
;
}
if(runtime.contextOrFrameLookup(context, frame, "currentItemWrapWithTagname")) {
t_21 += "<";
t_21 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentItemWrapWithTagname"), env.opts.autoescape);
t_21 += " class=\"c-breadcrumb__";
t_21 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentItemWrapWithTagname"), env.opts.autoescape);
t_21 += "\">";
;
}
t_21 += "<span aria-label=\"current page\" class=\"c-breadcrumb__span\" data-qa-breadcrumb-h1>\n\n                                                    ";
var t_28;
t_28 = runtime.contextOrFrameLookup(context, frame, "currentItemWrapWithTagname") && runtime.contextOrFrameLookup(context, frame, "currentItemWrapWithTagname") == "h1";
frame.set("titleIsH1", t_28, true);
if(frame.topLevel) {
context.setVariable("titleIsH1", t_28);
}
if(frame.topLevel) {
context.addExport("titleIsH1", t_28);
}
t_21 += "\n                                                    ";
var t_29;
t_29 = runtime.memberLookup((t_19),"seo") && runtime.memberLookup((runtime.memberLookup((t_19),"seo")),"h1TagOverride") && env.getFilter("lower").call(context, runtime.memberLookup((runtime.memberLookup((t_19),"seo")),"h1TagOverride")) != "none";
frame.set("hasTitleOverride", t_29, true);
if(frame.topLevel) {
context.setVariable("hasTitleOverride", t_29);
}
if(frame.topLevel) {
context.addExport("hasTitleOverride", t_29);
}
if(runtime.contextOrFrameLookup(context, frame, "titleIsH1") && runtime.contextOrFrameLookup(context, frame, "hasTitleOverride")) {
t_21 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_19),"seo")),"h1TagOverride"), env.opts.autoescape);
;
}
else {
t_21 += runtime.suppressValue(runtime.memberLookup((t_19),"displayName"), env.opts.autoescape);
;
}
t_21 += "</span>";
if(runtime.contextOrFrameLookup(context, frame, "currentItemWrapWithTagname")) {
t_21 += "</";
t_21 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentItemWrapWithTagname"), env.opts.autoescape);
t_21 += ">";
;
}
t_21 += "\n                                            </li>\n\n                                        ";
;
}
t_21 += "\n\n                                    ";
;
}
t_21 += "\n                                ";
;
frame = frame.pop();
return new runtime.SafeString(t_21);
});
return macro_t_20;})()})])), env.opts.autoescape);
t_11 += "\n                            ";
;
}
}
frame = frame.pop();
t_11 += "\n                        ";
;
}
t_11 += "\n                    </ol>\n\n                </nav>\n            </div>\n        </div>\n    </div>\n    ";
;
}
t_11 += "\n";
;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
context.addExport("buildBreadcrumb");
context.setVariable("buildBreadcrumb", macro_t_10);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/breadcrumb-macro.j2"] , dependencies)